import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, DISABLED_DURATIONS, getShouldHideSegments } from "../utils";

export const TrafficShareGroup = {
    id: "SegmentsGroupTrafficShare",
    properties: {
        order: "2",
        dropdownOrder: 2,
        hasWebSource: true,
        component: "CustomSegments",
        isHidden: getShouldHideSegments,
        mobileWebComponent: "MobileWebSearch",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        title: "segments.group.analysis.tab.trafficshare.title",
        group: "WebsiteAudienceOverview",
        family: SEGMENTS_FAMILY_NAME,
        dashboard: "true",
        compareOnly: "true",
        state: "digitalsuite_segments-analysis-traffic",
        apiController: "CustomSegments",
        webSource: "Desktop",
        availabilityComponent: "CustomSegments",
        periodOverPeriodSupport: true,
        totalComponent: "TotalWebCustomSegmentsAnalysis",
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
        disabledDurations: DISABLED_DURATIONS,
    },
    widgets: {
        single: {
            defaultType: "SegmentsGroupTrafficShareGraph",
            SegmentsGroupTrafficShareGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double",
                    format: "percentagesign",
                    formatParameter: 0,
                    name: "TrafficShare",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "SegmentsGroupTrafficShareGraph",
            SegmentsGroupTrafficShareGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double",
                    format: "percentagesign",
                    formatParameter: 0,
                    name: "TrafficShare",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};
